import * as actionTypes from "./actionTypes";
import api from "./apiAlpha";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import {
  LOAD_FOLDER_GENERAL_INFO_STARTED,
  LOAD_FOLDER_GENERAL_INFO_SUCCESS
} from "features/folder/edit/generalData/info/actionTypes";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadFolderHeaderAlpha(documentId, siteId) {
  return async (dispatch, getState) => {
    let folderHeader = getState().currentFolder.header;
    if (folderHeader.documentId === documentId && folderHeader.loaded) return folderHeader;

    try {
      if (folderHeader.loading === false) {
        dispatch({ type: actionTypes.LOAD_FOLDER_HEADER_STARTED });
        dispatch({ type: LOAD_FOLDER_GENERAL_INFO_STARTED });

        folderHeader = await dispatch(sendHttpRequest(api.getFolderHeaderAlpha(documentId, siteId)));
        const { generalInfo, client } = folderHeader;

        delete folderHeader.generalInfo;
        delete folderHeader.client;

        dispatch({
          type: actionTypes.LOAD_FOLDER_HEADER_SUCCESS,
          payload: {
            folderHeader: { ...folderHeader, client: { clientId: client.clientId, partnerId: client.partnerId } }
          }
        });
        dispatch({ type: LOAD_FOLDER_GENERAL_INFO_SUCCESS, payload: { generalInfo } });
        dispatch({ type: actionTypes.LOAD_FOLDER_PARTNER_SUCCESS, payload: { partner: { ...client } } });
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
